module.exports = __webpack_public_path__ + "img/score.cb3c58a5.svg";